export default "An email has been sent to you.\n\nFollow the link provided to set your new password."